import { sortBy } from 'lodash';

import {
  RegistrationResult,
  UserResult,
  searchRegistrationOrUser,
} from '@shared/events/endpoints/searchRegistrationOrUser';
import { Options, OptionsQuery } from '@shared/ui/components/Select';

import { GlobalSearchResult } from '@admin/layout/components/GlobalSearch/GlobalSearchUserResult';

export async function searchRegistrationOrUserOptions(eventId: number, { search }: OptionsQuery): Promise<Options> {
  const { users, registrations } = await searchRegistrationOrUser(eventId, search ?? '');

  // @ts-expect-error
  const registrationsAndUsers: Array<UserResult | RegistrationResult> = users.concat(registrations);

  return sortBy(registrationsAndUsers, 'score', 'desc').map((registrationOrUser) => {
    if ('userId' in registrationOrUser) {
      return {
        label: (
          <GlobalSearchResult icon="user">
            {registrationOrUser.firstName} {registrationOrUser.lastName}
          </GlobalSearchResult>
        ),
        value: `/admin/users/${registrationOrUser.userId}/registrations`,
      };
    }

    if ('registrationId' in registrationOrUser) {
      return {
        label: <GlobalSearchResult icon="company">{registrationOrUser.name}</GlobalSearchResult>,
        value: `/admin/registrations/${registrationOrUser.registrationId}/edit`,
      };
    }

    throw new Error('Unknown result');
  });
}
